import React from "react";
import GripList from "../../components/figure/GripList";

const GripsPage = () => {
    return <GripList/>
}

export default GripsPage;
